<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CheckModal from "@/components/CheckModal";
import Swal from "sweetalert2";
import absenceOtherCauseAPI from "@/services/standards/medicionAusentismo/absenceOtherCauseAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";

export default {
  page: {
    title: "3.3.6 Ausentismo por otras causas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal },
  data() {
    return {
      title: "3.3.6 Ausentismo por otras causas",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "Ausentismo por otras causas", active: true },
      ],
      itemData: null,
      loading: true,
      submitting: false,
      causeTypes: [],
      usersList: [],
      lista: [],
      file: null,
      lastId: 1,
      editingId: null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      form: {
        employee_id: null,
        cause_type: null,
        start_date: null,
        final_date: null,
        days: null,
        motivo: null,
        file: null,
      },
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(40).then((r) => { this.itemData = r; }).catch((e) => console.log(e));
    },
    allowAccess() {
      try {
        const item = this.itemData;
        if (!item) return false;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) { console.log(e); return false; }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const permissions = this.$store.state.auth.info.permissions;
      const enabled = permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    dateConvert(d) { return d ? String(d).substring(0, 10) : ""; },
    resetForm() {
      this.editingId = null;
      this.file = null;
      this.form = { employee_id: null, cause_type: null, start_date: null, final_date: null, days: null, motivo: null, file: null };
    },
    uploadFile() { this.file = this.$refs.file.files[0]; },
    async uploadDocument() {
      if (!this.file) return true; // soporte opcional
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${base}/${this.nit}/3.3.6/ausentismo-otras/${this.lastId}/${this.file.name}`;
        const ok = await uploadDocument(path, this.file);
        if (ok) { this.form.file = `${process.env.VUE_APP_BUCKET}/${path}`; return true; }
        return false;
      } catch (e) { console.log(e); return false; }
    },
    async save() {
      if (!this.form.employee_id || !this.form.cause_type || !this.form.start_date || !this.form.final_date || this.form.days === null) {
        Swal.fire("Alerta", "Completa los campos obligatorios", "warning");
        return;
      }
      this.submitting = true;
      const ok = await this.uploadDocument();
      if (!ok) { this.submitting = false; Swal.fire("Error", "No se pudo subir el soporte", "error"); return; }
      const payload = { ...this.form, companies_id: this.companyID };
      const req = this.editingId ? absenceOtherCauseAPI.update(this.editingId, payload) : absenceOtherCauseAPI.save(payload);
      req
        .then(() => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 40, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Registro guardado.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          this.resetForm();
          this.getList();
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar", "error"); });
    },
    edit(dato) {
      this.editingId = dato.id;
      this.form = {
        employee_id: dato.employee_id,
        cause_type: dato.cause_type,
        start_date: this.dateConvert(dato.start_date),
        final_date: this.dateConvert(dato.final_date),
        days: dato.days,
        motivo: dato.motivo,
        file: dato.file,
      };
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    remove(id) {
      Swal.fire({ title: "¿Eliminar registro?", icon: "warning", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar" })
        .then((res) => {
          if (!res.value) return;
          absenceOtherCauseAPI.delete(id).then(() => { Swal.fire({ title: "Eliminado", icon: "success", timer: 1300, showConfirmButton: false }); this.getList(); })
            .catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
        });
    },
    getList() {
      absenceOtherCauseAPI.getAll(this.companyID)
        .then((res) => {
          this.lista = res && res.data && res.data.data ? res.data.data : [];
          if (this.lista[0] && this.lista[0].id) this.lastId = this.lista[0].id + 1;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    goBack() { this.$router.go(-1); },
    gotoFile(url) { window.open(url); },
  },
  mounted() {
    this.getItemData();
    absenceOtherCauseAPI.causeTypes().then((t) => { this.causeTypes = t; });
    absenceOtherCauseAPI.employeesList(this.companyID).then((u) => { this.usersList = u; });
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <CheckModal>
                <p class="text-justify">
                  Registra las ausencias del personal por causas <strong>no médicas</strong> (permisos, licencias,
                  calamidad, ausencias injustificadas, sanciones, comisiones, etc.). Estos días alimentan el reporte de
                  ausentismo por otras causas y el consolidado.
                </p>
              </CheckModal>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3 px-3">
                  <b-form-group class="col-md-6" label="Colaborador">
                    <select :disabled="!allowAccess() || !getRole('Crear')" required class="form-control" v-model="form.employee_id">
                      <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                      <b-form-select-option v-for="u in usersList" :key="u.id" :value="u.id">{{ u.full_name }}</b-form-select-option>
                    </select>
                  </b-form-group>
                  <b-form-group class="col-md-6" label="Tipo de causa">
                    <select :disabled="!allowAccess() || !getRole('Crear')" required class="form-control" v-model="form.cause_type">
                      <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                      <b-form-select-option v-for="c in causeTypes" :key="c" :value="c">{{ c }}</b-form-select-option>
                    </select>
                  </b-form-group>
                </div>

                <div class="form-row pt-2 px-3">
                  <b-form-group class="col-md-4" label="Fecha inicio">
                    <b-form-input required type="date" v-model="form.start_date" :disabled="!allowAccess() || !getRole('Crear')" />
                  </b-form-group>
                  <b-form-group class="col-md-4" label="Fecha fin">
                    <b-form-input required type="date" v-model="form.final_date" :disabled="!allowAccess() || !getRole('Crear')" />
                  </b-form-group>
                  <b-form-group class="col-md-4" label="Días de ausencia">
                    <b-form-input required type="number" min="0" v-model="form.days" :disabled="!allowAccess() || !getRole('Crear')" />
                  </b-form-group>
                </div>

                <div class="form-row pt-2 px-3">
                  <b-form-group class="col-md-8" label="Motivo / Observación">
                    <b-form-textarea v-model="form.motivo" rows="2" :disabled="!allowAccess() || !getRole('Crear')" />
                  </b-form-group>
                  <b-form-group class="col-md-4" label="Soporte (opcional)">
                    <b-form-file ref="file" v-model="file" browse-text="Buscar" placeholder="Selecciona un archivo..."
                      drop-placeholder="Suelta acá..." @change="uploadFile"
                      accept=".doc,.pdf,.xlsx,.xls,.docx,image/*" :disabled="!allowAccess() || !getRole('Crear')" />
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3">
                  <button :disabled="submitting" type="submit" class="btn btn-primary">{{ editingId ? 'Actualizar' : 'Guardar' }}</button>
                  <button v-if="editingId" type="button" class="btn btn-light mx-1" @click="resetForm">Nuevo</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>

                <hr v-if="getRole('Consultar')" />
                <div class="table-responsive" v-if="getRole('Consultar') || !allowAccess()">
                  <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                    <thead>
                      <tr>
                        <th class="text-center align-middle">Fecha inicio</th>
                        <th class="text-center align-middle">Fecha fin</th>
                        <th class="text-center align-middle">Colaborador</th>
                        <th class="text-center align-middle">Tipo de causa</th>
                        <th class="text-center align-middle">Días</th>
                        <th class="text-center align-middle">Motivo</th>
                        <th class="text-center align-middle">Soporte</th>
                        <th class="text-center align-middle">Acciones</th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-if="!lista.length"><td colspan="8" class="text-center text-muted">Sin registros.</td></tr>
                      <tr v-for="dato in lista" :key="dato.id">
                        <td class="text-center align-middle">{{ dateConvert(dato.start_date) }}</td>
                        <td class="text-center align-middle">{{ dateConvert(dato.final_date) }}</td>
                        <td class="text-center align-middle">{{ dato.full_name }}</td>
                        <td class="text-center align-middle">{{ dato.cause_type }}</td>
                        <td class="text-center align-middle">{{ dato.days }}</td>
                        <td class="text-center align-middle">{{ dato.motivo }}</td>
                        <td class="text-center align-middle">
                          <button v-if="dato.file" style="background:transparent !important; border:none;" type="button" @click="gotoFile(dato.file)">
                            <i class="mdi mdi-cloud-download"></i>
                          </button>
                          <span v-else class="text-muted small">—</span>
                        </td>
                        <td class="text-center align-middle">
                          <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                            <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                            <b-dropdown-item :disabled="!getRole('Editar')" @click="edit(dato)">Editar</b-dropdown-item>
                            <b-dropdown-item :disabled="!getRole('Eliminar')" @click="remove(dato.id)">Eliminar</b-dropdown-item>
                          </b-dropdown>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div v-else class="col-xl-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal { background-color: transparent !important; border: none; }
</style>
